var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroup164(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 78,
    viewBox: "0 0 55 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.566 97.4176C12.566 128.382 -12.3761 153.386 -43.0227 153.386C-73.6692 153.386 -98.6113 128.382 -98.6113 97.4176C-98.6113 66.453 -73.6692 41.4498 -43.0227 41.4498C-12.3761 41.4498 12.566 66.453 12.566 97.4176Z",
    stroke: "#D7D7D7",
    strokeOpacity: 0.4,
    strokeWidth: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -40.5,
    cy: 95.5,
    r: 85.5,
    stroke: "#D7D7D7",
    strokeOpacity: 0.17,
    strokeWidth: 20
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup164);
export default __webpack_public_path__ + "static/media/Group 164.978b58a24ab3df6cee488bb616163d99.svg";
export { ForwardRef as ReactComponent };